export function getApiBaseUrl(): string {
  const raw = import.meta.env.VITE_API_BASE_URL?.trim();
  if (!raw) {
    throw new Error("VITE_API_BASE_URL is required");
  }
  return raw.replace(/\/$/, "");
}
